let mnHtmlEditorCustomObject = {};

export function setMnHtmlEditorCustomization(customObject) {
  mnHtmlEditorCustomObject = customObject;
}

export function getMnHtmlEditorCustomization() {
  return mnHtmlEditorCustomObject;
}